module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image6n.42440e96.jpg";